import { render } from "./updataOrder.vue?vue&type=template&id=4160fb9e&scoped=true"
import script from "./updataOrder.vue?vue&type=script&lang=js"
export * from "./updataOrder.vue?vue&type=script&lang=js"

import "./updataOrder.vue?vue&type=style&index=0&id=4160fb9e&lang=css"
import "./updataOrder.vue?vue&type=style&index=1&id=4160fb9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4160fb9e"]])

export default __exports__